import React from 'react';
import PropTypes from 'prop-types';
import { AttributeTable } from '@itds/elements/index.js';
import { ZeroState } from '@itds/components/index.js';

const Quote = ({ quote }) => {
  let formatted_quote;

  if (quote) {
    const { product, health_category, ...other_attr } = quote;

    formatted_quote = {
      ...other_attr,
      product: [`${product.product_name} (ID: ${product.id})`],
      health_category: [`${health_category.carrier_health_category} (ID: ${health_category.id})`]
    };
  }
  return quote ? (
    <AttributeTable
      data={formatted_quote}
      headers={[
        { label: 'Attribute', textAlign: 'right' },
        { label: 'Value', textAlign: 'left' }
      ]}
    />
  ) : (
    <ZeroState icon='currency-usd' title='No quote found for this lead.' />
  );
};

Quote.propTypes = {
  quote: PropTypes.object
};

export default Quote;
